exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-52956b39]{max-width:none!important}.success--text[data-v-52956b39]{color:green}.error--text[data-v-52956b39]{color:red}", ""]);

// exports
